var _path, _path2, _path3, _circle, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIdCard = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-id-card-icon lucide-id-card",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 10h2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 14h2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.17 15a3 3 0 0 1 5.66 0"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 11,
  r: 2
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 5,
  width: 20,
  height: 14,
  rx: 2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIdCard);
export { ForwardRef as ReactComponent };